import { render, staticRenderFns } from "./threeGift.vue?vue&type=template&id=66795ebb&"
import script from "./threeGift.vue?vue&type=script&lang=js&"
export * from "./threeGift.vue?vue&type=script&lang=js&"
import style0 from "./threeGift.vue?vue&type=style&index=0&id=66795ebb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports